import React from 'react';
import { Layout } from 'antd';
import { FormattedMessage, FormattedHTMLMessage,   injectIntl } from 'react-intl';
import GuideNav from '../../components/navigation/GuideNav';
import Headline from '../../components/Headline';
import GuideBoxUI from '../../components/GuideBoxUI';


const data = {
  caution : {
      title: {
          id : 'SelectTag.guide.modal.caution.title',
          text : 'Things to note when selecting tags'
      },
      description: {
          id : 'SelectTag.guide.modal.caution.description',
          text: '<ul style="list-style-type:decimal; padding-left:15px;"><li>Each sticker can have <strong>a minimum of 1 tag and a maximum of 3 tags</strong> selected.</li><li>If <strong>tags do not match the emotion or situation presented,</strong> the sticker <strong>may be rejected.</strong></li><li>Stickers without tags selected cannot be submitted.</li></ul>'
      }
  }
}



const tagSelectionColumn = [
  {
    title: <img src={require('../../img/upload/guide_modal/icon_right.svg').default} alt="o"/>,
    dataIndex:'right',
    width:280
  },{
    title: <img src={require('../../img/upload/guide_modal/icon_wrong.svg').default} alt="x"/>,
    dataIndex:'wrong',
    width:280
  }
];
const tagSelectionData =  [{
  key: '1',
  right: 
    <FormattedHTMLMessage
      id="SelectTag.guide.modal.explain.right"
      defaultMessage="ul><li>An emotion or situation that can be inferred from the sticker</li><li>The first tag that comes to mind when looking at the sticker</li><li>A tag that intuitively matches<br/>the sticker</li></ul>"
    />,
  wrong:  
    <FormattedHTMLMessage
      id="SelectTag.guide.modal.explain.wrong"
      defaultMessage="<ul><li>An emotion or situation that can not <br/>be inferred from the sticker</li><li>An element that has nothing to do with<br/>the sticker’s emotion or situation</li></ul>"
    />
}];

let SelectTags = props => (
  <Layout style={{background: '#fff' }}>
    <GuideNav selectedKey={"selectTags"} location={props.location}/>
    <Layout.Content style={{margin:20}}>
      <Headline id="Guide.selectTags.headline" defaultMessage="How to Select Tags"
        styles={{margin: '22px 0px 0px 0px', fontFamily: 'NotoSans', fontSize: '34px', lineHeight: '36px', letterSpacing: 0}}
      />
      <div className="guide-wrapper">
        <div className="importance-tag-description">
          <FormattedHTMLMessage
            id="Guide.selectTags.description"
            defaultMessage="Mojitok is a service that uses AI to analyze a user's message and recommend appropriate stickers. Tag input is crucial as Mojitok’s AI <strong>matches the sticker to the user's message based on the tag entered when uploading the sticker.</strong>"
          />
          <div className="example-tag-gif">
            <img src={require(`../../img/guide/select_tags/tag_clap_${props.intl.locale}.gif`).default} alt="example_clap_tag"/>
            <img src={require(`../../img/guide/select_tags/tag_goodnight_${props.intl.locale}.gif`).default} alt="example_goodnight_tag"/>
          </div>
        </div>
        <GuideBoxUI
          imgIcon={require('../../img/guide/format_icon_checklist.svg').default}
          title={{
            id: 'Guide.selectTags.tagSelection.title',
            defaultMessage :'Tag Selection'
          }}
          table={{
            column : tagSelectionColumn,
            data: tagSelectionData,
            className : 'tag-selection-table'
          }}
        />
        <div className="tag-guide-caution">
          <GuideBoxUI
            imgIcon={require('../../img/guide/format_icon_precautions.svg').default}
            title={{
              id: 'Guide.selectTags.caution.title',
              defaultMessage :'Things to Note When Selecting Tags'
            }}
            description={{
              id: data.caution.description.id,
              defaultMessage : data.caution.description.text
            }}
          />
        </div>
        <div>
          <GuideBoxUI
            imgIcon={require('../../img/guide/format_icon_alarm.svg').default}
            title={{
              id: 'Guide.frequentMistakes',
              defaultMessage :'Frequent mistakes!'
            }}
          />
          {
            [1,2,3,4].map(value => 
              <div className="tag-guide-mistake" key={value} style={{letterSpacing: [2,3,4].includes(value) && props.intl.locale === 'en' ? -0.4 : 0}}>
                  <FormattedMessage id={`Guide.selectTags.mistake.title.${value}`}/>
                  <div className="frequent-mistakes-text tag-guide-mistake-description">
                    <img src={require(`../../img/guide/select_tags/mistake_ex_${value}@2x.png`).default} width={303} alt="mistake-example"/>
                    <FormattedHTMLMessage id={`Guide.selectTags.mistake.description.${value}`}/>
                  </div>
              </div>
            )
          }
        </div>

      </div>
    </Layout.Content>
  </Layout>
)

  
SelectTags=injectIntl(SelectTags);
export default SelectTags;